import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { EditModeProvider } from './context/EditModeContext';
import { AuthProvider } from './context/AuthContext';
import Toolbar from './components/Toolbar';
import Login from './pages/Login';
import PropiedadesList from './pages/PropiedadesList';
import PropiedadDetail from './pages/PropiedadDetail';
import ProtectedRoute from './components/ProtectedRoute';

const theme = createTheme({
  palette: {
    primary: {
      main: '#667eea',
    },
    secondary: {
      main: '#764ba2',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <EditModeProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Toolbar />
                    <Routes>
                      <Route path="/" element={<PropiedadesList />} />
                      <Route path="/propiedad/:id" element={<PropiedadDetail />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </EditModeProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

